import createCartSlice from './cartSlice';
import createShowroomSlice from './showroomSlice';
import createWishlistSlice from './wishlistSlice';

const createHeaderItemsSlice = (set, get, store) => ({
  getHeaderProducts() {
    createCartSlice(set, get, store).getCartItems();
    createWishlistSlice(set, get, store).getWishlist();
  },
  getHeaderItems() {
    createCartSlice(set, get, store).getCartItems();
    createWishlistSlice(set, get, store).getWishlist();
    createShowroomSlice(set, get, store).getShowrooms();
  },
});

export default createHeaderItemsSlice;
